import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import BackPain from './pages/BackPain';
import SportsInjury from './pages/SportsInjury';
import PostSurgery from './pages/PostSurgery';
import ElderlyCare from './pages/ElderlyCare';
import Confirmation from './pages/Confirmation';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/back-pain" element={<BackPain />} />
        <Route path="/sports-injury" element={<SportsInjury />} />
        <Route path="/post-surgery" element={<PostSurgery />} />
        <Route path="/elderly-care" element={<ElderlyCare />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </Router>
  );
}

export default App;